import angular from "angular";
import $ from 'jquery';

angular
    .module('ui-sentinel.login')
    .controller('LoginController', LoginController);

/////////////

export function classifyLoginError(error) {
    const data = error && error.data ? error.data : {};
    const isWebLoginFailure = error && error.status === 401;
    const errorDescription = (data.error_description || '').toLowerCase();
    const isSuspended = data.error === 'suspended_client'
        || (data.error === 'invalid_grant' && errorDescription === 'account has been suspended');

    if (isWebLoginFailure && isSuspended) {
        return 'suspended';
    }

    if (isWebLoginFailure && data.error === 'invalid_grant') {
        return 'invalid_credentials';
    }

    return 'server';
}

const failureTextLimit = 200;

/**
 * What the browser saw when a login ended on the server-error path, for the API's
 * client-event log. A real HTTP answer carries its status and error body; a request that
 * never got one carries status -1 and the AngularJS xhrStatus ('error', 'abort' or
 * 'timeout'), which is what separates a dropped connection from a page that cancelled its
 * own request. Anything that is not an HTTP response (a thrown Error) carries its message.
 * Never includes the password.
 */
export function describeLoginFailure(error, context) {
    const response = error && typeof error.status === 'number' ? error : null;
    const data = response && response.data && typeof response.data === 'object' ? response.data : {};
    const textBody = response && typeof response.data === 'string' ? response.data : null;

    return {
        event: 'web-login-failed',
        status: response ? response.status : null,
        xhrStatus: response && response.xhrStatus ? response.xhrStatus : null,
        error: data.error || null,
        errorDescription: truncate(data.error_description || textBody),
        message: !response && error && error.message ? truncate(String(error.message)) : null,
        elapsedMs: typeof context.startedAt === 'number' ? Math.max(0, Math.round(context.now - context.startedAt)) : null,
        online: typeof context.online === 'boolean' ? context.online : null,
        bundle: context.bundle || null,
        staleBundle: typeof context.staleBundle === 'boolean' ? context.staleBundle : null,
        page: context.page || null,
        login: context.login || null,
        at: new Date(context.now).toISOString()
    };

    function truncate(text) {
        if (!text) {
            return null;
        }
        return String(text).slice(0, failureTextLimit);
    }
}

LoginController.$inject = ['$rootScope', '$state', '$interval', '$window', 'SentinelUiSession', 'SentinelAuthenticationService', 'ClientVersionService', 'SENTINEL_API_HOST_CONSTANTS'];

function LoginController($rootScope, $state, $interval, $window, SentinelUiSession, SentinelAuthenticationService, ClientVersionService, HOST) {

    const vm = {
        username: {
            value: null,
            isPristine: true,
            hasError: function () {
                return this.errors.isBlank;
            },
            errors: {
                isBlank: true
            },
            validate: function () {
                this.isPristine = false;
                this.errors.isBlank = !this.value;
            }
        },
        password: {
            value: null,
            isPristine: true,
            hasError: function () {
                return this.errors.isBlank;
            },
            errors: {
                isBlank: true
            },
            validate: function () {
                this.isPristine = false;

                if (!this.value) {
                    this.errors.isBlank = true;
                } else {
                    this.value = this.value.trim();
                    this.errors.isBlank = this.value === '';
                }
            }
        },
        inProcess: false,
        login: login,
        loginFailed: false,
        loginSuspend: false,
        serverError: false,
        date: new Date(),
        isOrs: $rootScope.isOrs,
        loginTitle: $rootScope.isOrs ? 'Login' : 'OAInsight Login',
        redirectUrl: null,
        redirectCountdown: 5
    };

    // listen for clientRedirect event
    $rootScope.$on('clientRedirect', function(event, redirectUrl) {
        vm.redirectUrl = redirectUrl;
        vm.redirectCountdown = 5;
        $('#clientRedirectModal').modal('show');

        const countdownInterval = $interval(function() {
            vm.redirectCountdown--;
            if (vm.redirectCountdown <= 0) {
                $interval.cancel(countdownInterval);
                window.location.href = redirectUrl;
            }
        }, 1000);
    });

    return vm;

    function login() {
        vm.inProcess = true;
        vm.loginFailed = false;
        vm.serverError = false;

        $('#btn-login').blur();

        if (!vm.username.value) {
            // check broken autofill...
            const check = $('#username').val();
            if (check) {
                vm.username.value = check;
                vm.username.isPristine = true;
            }
        }

        if (!vm.password.value) {
            // check broken autofill...
            const check = $('#password').val();
            if (check) {
                vm.password.value = check;
                vm.password.isPristine = true;
            }
        }

        vm.username.validate();
        vm.password.validate();

        if (vm.username.hasError() || vm.password.hasError()) {
            vm.inProcess = false;
            vm.loginFailed = true;
            return;
        }

        $rootScope.loading = true;
        const startedAt = Date.now();
        const promise = SentinelUiSession.login(vm.username.value.trim(), vm.password.value.trim());
        promise.then(
            function (result) {
                vm.inProcess = false;
                if (!result.redirected) {
                    onSessionCreated();
                }
            },
            function (error) {
                vm.inProcess = false;
                if (SentinelUiSession.isSupersededResponse(error)) {
                    return;
                }
                const loginError = classifyLoginError(error);
                vm.loginSuspend = loginError === 'suspended';
                vm.loginFailed = loginError === 'invalid_credentials';
                vm.serverError = loginError === 'server';
                if (vm.serverError) {
                    reportLoginFailure(error, startedAt);
                }
                SentinelUiSession.clear();
                $rootScope.loading = false;
            }
        ).finally(function () {
            // do not set $rootScope.loading = false
            // this causes the gears to disappear and then reappear on login
        });
    }

    function onSessionCreated() {
        $state.go('home');
    }

    function reportLoginFailure(error, startedAt) {
        try {
            const navigator = $window.navigator || {};
            const location = $window.location || {};
            SentinelAuthenticationService.reportLoginFailure(describeLoginFailure(error, {
                login: vm.username.value,
                startedAt: startedAt,
                now: Date.now(),
                online: navigator.onLine,
                bundle: HOST.CLIENT_VERSION,
                staleBundle: ClientVersionService.isStale(),
                page: (location.pathname || '') + (location.hash || '')
            }));
        } catch (reportError) {
            // A diagnostic must never add to the failure it describes.
        }
    }

}
